/**
 * @generated SignedSource<<f05ecb00d47e167484c0679ee1894e02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarkTxnsInternalInputObject = {
  destinationBankAccountId?: string | null | undefined;
  destinationName?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type revenueCellPanel_MarkTxnsInternalMutation$variables = {
  input: MarkTxnsInternalInputObject;
};
export type revenueCellPanel_MarkTxnsInternalMutation$data = {
  readonly markTxnsInternal: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type revenueCellPanel_MarkTxnsInternalMutation = {
  response: revenueCellPanel_MarkTxnsInternalMutation$data;
  variables: revenueCellPanel_MarkTxnsInternalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "revenueCellPanel_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "revenueCellPanel_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4c05104e0f3d8d7acb3a07ad1b21560b",
    "id": null,
    "metadata": {},
    "name": "revenueCellPanel_MarkTxnsInternalMutation",
    "operationKind": "mutation",
    "text": "mutation revenueCellPanel_MarkTxnsInternalMutation(\n  $input: MarkTxnsInternalInputObject!\n) {\n  markTxnsInternal(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b579ada29d2980cb674602b2aae42ca8";

export default node;
